import api from "@/services/api.service";

export default {
    name: 'list',
    components: {},
    props: {
        caption: {
            type: String,
            default: 'Campaign list'
        },
        hover: {
            type: Boolean,
            default: true
        },
        striped: {
            type: Boolean,
            default: true
        },
        bordered: {
            type: Boolean,
            default: false
        },
        small: {
            type: Boolean,
            default: false
        },
        fixed: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            newRecords: [],
            allRecords: [],
            icon: 'fa fa-sort',
            selcol: '',
            search:'',
            filter: null,
            fields: [
            {key: 'first_name',sortable: false},
            {key: 'last_name',sortable: false},
            {key: 'personal_email',sortable: false},
            {key: 'personal_phone',sortable: false},
            {key: 'business_email',sortable: false},
            {key: 'business_phone',sortable: false},
            {key: 'actions'}
            ],
            currentPageNew: 1,
            perPageNew: 10,
            totalRowsNew: 0,
            currentSortDir:'desc',
            currentPageAll: 1,
            perPageAll: 10,
            totalRowsAll: 0,
            isBusy: true,
            status: 'new',
            colName : '',
            permission_list: false,
            permission_add: false,
            permission_edit: false,
            permission_delete: false,
            permission_view: false,
            superAdmin: false
        }
    },
    computed: {},
    mounted() {

    },
    created() {
        this.getUserPermissions();
        this.getResultData('all');
    },
    watch: {
        currentPageNew: {
            handler: function(page) {
                this.getResultData('new',page)
                this.toSort(this.colName,page);

            }
        },
        currentPageAll: {
            handler: function(page) {
                // this.getResultData('all',page)
                this.toSort(this.colName,page);

            }
        }
    },
    methods: {
        makeToast(message = '', title = 'Alert', variant = 'warning') {
            this.toastCount++
            this.$root.$bvToast.toast(message, {
                title: title,
                variant: variant,
                autoHideDelay: 3000
            })
        },
        async getUserPermissions(){
            let response = await api.post("users/user-permissions");
            const permissions = [];
            if (response.status == "success") {
              response.data[0].permission.forEach( function(element) {                
                  permissions.push(element.action)
              }.bind(this));
              this.permission_list = permissions.includes("list_contact");
              this.permission_add = permissions.includes("add_contact");
                if(this.permission_list == true || this.permission_add == true){
                    this.permission_edit = permissions.includes("edit_contact");
                    this.permission_delete = permissions.includes("delete_contact");      
                    this.permission_view = permissions.includes("view_details_contact");
                }else if(response.data[0].role == 'super_admin'){
                    this.superAdmin = true;
                }else{
                    this.makeToast("Permission denied","Alert","warning",6000);
                    this.$router.push({name: 'Admin Dashboard'});
                }
            }      
          },
            async toSort (allRecords,page = 1)
            {
                if (allRecords != "actions") {                
                    if(page == 1)
                    if(allRecords == this.colName)
                    this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc';  

                    this.isBusy = true;
                    this.colName = allRecords;
                    let response = await api.post("contact/list", {page:page,columnname:allRecords,sortType:this.currentSortDir,paginateVal:this.perPageAll});
                    if (response.status == "success")
                    {
                        if (response.data != ""){
                            if(this.currentSortDir == 'asc'){
                                this.icon1 = 'fa fa-sort-up';                             
                                this.selcol = allRecords;        
                            } else{ 
                                this.icon1 = 'fa fa-sort-down';                             
                                this.selcol = allRecords;
                            }
                            this.allRecords = [];
                            // this.allRecords = response.data.data
                            response.data.data.forEach(element => {
                                this.allRecords.push(element)
                            });
                            this.totalRowsAll = response.data.total;
                            this.currentPageAll = response.data.current_page;
                            this.perPageAll = response.data.per_page;  
                        } else {
                            this.allRecords = [];
                        }
                    } 
                    this.isBusy = false;   
                }                
            },
            async getContact() {
                this.isBusy=true;
                let response = await api.post('contact/list', this.sech);
                if (!response)
                    this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

                if (response.status == 'success') {
                    if (response.data != '')
                        this.items = response.data
                    else {
                        this.items = [];
                    }
                }
                this.isBusy=true;
            },
            async getResultData(status,page=1) {
                this.isBusy=true;
                let response = await api.post('contact/list', {'page':page,'status': status, 'search': this.search, paginateVal:this.perPageAll});
                if (!response)
                    this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

                if (response.status == 'success') {
                    if (response.data != '') {                    
                        this.allRecords = response.data.data
                        this.totalRowsAll = response.data.total;
                        this.currentPageAll = response.data.current_page;
                        this.perPageAll = response.data.per_page;   
                        
                        this.pageOptions.forEach(element => {
                            if(element.value > this.totalRowsAll){
                                var indexOf = this.pageOptions.indexOf(element);
                                if( indexOf != 0 )
                                this.pageOptions.splice(indexOf)
                            }
                        });
                        if(this.totalRowsAll <= 500)
                        this.pageOptions.push({text:'All',value:this.totalRowsAll});
                    } else {                    
                        this.allRecords = []
                    }
                    this.isBusy=false;
                }
            },
            getRowCount(items) {
                return items.length
            },
            editContact(item) {
                this.$router.push({name: 'Edit Contact', params: {id: item.item.id}})
            },
            showConfirmBox(id,index,status) {
                this.$bvModal.msgBoxConfirm('Are you sure want to delete this contact?')
                .then(value => {
                    if(value){
                        this.deleteContact(id,index,status)
                    }else{
                        return;
                    }
                })
                .catch(function () {
                    return;
                })
            },
            async deleteContact(id,index) {
                let response = await api.post('contact/delete', {"id": id});
                if (!response)
                    this.makeToast("Something went to wrong please try again", 'Alert', 'danger', 6000)

                if (response.status == 'success') {                
                    this.allRecords.splice(index,1);               
                    this.makeToast(response.message || `Contact delete successful.`, 'Alert', 'success')
                } else
                this.makeToast(`Contact not deleted.`, 'Alert', 'danger')
            },
            contactView (id) {
                this.$router.push({name: 'View Contacts', params: {id: id}})
            }
        }
    }


